import React from 'react';
import { Select as AntSelect } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';

/**
 * Select styled to match the search input (RolesSearchInput): same height (44px),
 * colors, border, border-radius, and font. Use for filters and dropdowns that
 * should look like the search box.
 */
const StyledSelect = styled(AntSelect)`
    min-width: ${({ $compact }) => ($compact ? '120px' : '160px')};
    width: ${({ $width }) => $width ?? 'auto'};
    font-family: var(--font-family-geist) !important;

    &.ant-select-single {
        height: ${({ $compact }) => ($compact ? '26px' : '44px')};
    }

    .ant-select-selector {
        height: ${({ $compact }) => ($compact ? '26px' : '44px')} !important;
        min-height: ${({ $compact }) => ($compact ? '26px' : '44px')} !important;
        padding: ${({ $compact }) => ($compact ? '0 8px' : '0 16px')} !important;
        border-radius: ${({ $compact }) => ($compact ? '6px' : '8px')} !important;
        border: 1px solid
            ${({ theme }) => (theme?.colors?.background?.default === '#141414' ? '#2C2C2C' : '#E5E5E5')} !important;
        background: ${({ theme }) => (theme?.colors?.background?.default === '#141414' ? '#2C2C2C' : '#F0F0F0')} !important;
        align-items: center !important;
        transition: border-color 0.2s;
    }

    .ant-select-selection-placeholder,
    .ant-select-selection-item {
        color: ${({ theme }) => (theme?.colors?.background?.default === '#141414' ? '#fff' : '#000')} !important;
        font-size: ${({ $compact }) => ($compact ? '12px' : '14px')} !important;
        line-height: ${({ $compact }) => ($compact ? '24px' : '42px')} !important;
    }

    .ant-select-selection-placeholder {
        color: ${({ theme }) =>
            theme?.colors?.background?.default === '#141414' ? 'rgba(255,255,255,0.5)' : '#8c8c8c'} !important;
    }

    &.ant-select-focused:not(.ant-select-disabled) .ant-select-selector {
        border-color: ${({ theme }) =>
            theme?.colors?.background?.default === '#141414' ? '#595959' : '#d9d9d9'} !important;
        box-shadow: none !important;
    }

    &:hover:not(.ant-select-disabled) .ant-select-selector {
        border-color: ${({ theme }) =>
            theme?.colors?.background?.default === '#141414' ? '#595959' : '#d9d9d9'} !important;
    }

    .ant-select-arrow {
        color: ${({ theme }) =>
            theme?.colors?.background?.default === '#141414' ? 'rgba(255,255,255,0.65)' : '#8c8c8c'} !important;
        font-size: 12px;
    }

    @media (max-width: 768px) {
        min-width: ${({ $compact }) => ($compact ? '100px' : '140px')};
        &.ant-select-single .ant-select-selector {
            height: ${({ $compact }) => ($compact ? '24px' : '40px')} !important;
            min-height: ${({ $compact }) => ($compact ? '24px' : '40px')} !important;
        }
        .ant-select-selection-item,
        .ant-select-selection-placeholder {
            line-height: ${({ $compact }) => ($compact ? '22px' : '38px')} !important;
        }
    }
`;

export const Select = React.forwardRef(({ $width, $compact, ...props }, ref) => (
    <StyledSelect ref={ref} $width={$width} $compact={$compact} {...props} />
));

Select.displayName = 'Select';

Select.propTypes = {
    $width: PropTypes.string,
    $compact: PropTypes.bool,
};

export default Select;
